var path = '/components/views/select-passbook-model-modal.tpl.html';
var html = "<button class=\"close\" ng-click=\"vm.close()\"><i class=\"fal fa-times\"></i></button>\n<div class=\"modal-header\">\n    <h2>Download Sample {{vm.title}}</h2>\n</div>\n<div class=\"modal-body\">\n    <p>To download a sample {{vm.title}}, you have to select a contact or booking which will be used to fill the data on the\n        pass.</p>\n\n    <div class=\"btn-group\">\n        <button class=\"button btn-confirm\" ng-click=\"vm.selectContact()\">Select Contact</button>\n        <button class=\"button btn-confirm\" ng-click=\"vm.selectRsvp()\">Select Booking</button>\n    </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/views/select-passbook-model-modal.tpl.html
// module id = 2050
// module chunks = 1